var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"block-title"},[_vm._t("default"),(_vm.$slots.btn)?_c('el-button-group',{staticClass:"block-title_btn"},[_vm._t("btn")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }